export const EVENT_401 = 'event-401'
export const EVENT_503 = 'event-503'
export const EVENT_LOCATION_CHANGE = 'location-change'
export const EVENT_TICKET_CREATED = 'ticket-created'
export const EVENT_TICKET_COMMENT_CREATED = 'ticket-comment-created'
export const EVENT_CLOSE_ALL_DROPDOWN = 'close-all-dropdown'
